<template>
    <div class="mt-4 border-b border-sidebar-border">
        <div v-if="$page.props?.auth?.user">
            <div
                @click="$emit('toggleProfileMenu')"
                :class="[
                    padding,
                    'relative py-6 overflow-hidden flex flex-col gap-y-4 underline-hover transition-colors duration-button-hover cursor-pointer',
                ]"
            >
                <div
                    class="h-16 w-16 rounded-full border border-border overflow-hidden flex justify-center items-center"
                >
                    <img
                        v-if="
                            $page.props?.auth?.user.picturePath &&
                            !hadImageError
                        "
                        class="w-full h-full bg-gray-50 object-cover flex-shrink-0"
                        :src="$page.props?.auth?.user.picturePath"
                        @error="() => (hadImageError = true)"
                        alt=""
                    />
                    <PhUser v-else class="text-user-accent bg-user size-full" />
                </div>
                <div>
                    <p
                        class="text-ellipsis overflow-hidden font-medium md:font-normal"
                        aria-hidden="true"
                        v-text="$page.props?.auth?.user.name"
                    />
                    <p
                        v-if="$page.props?.auth?.user.typeRole"
                        class="text-sm italic text-ellipsis overflow-hidden text-gray-400"
                        v-text="$page.props?.auth?.user.typeRole"
                    />
                </div>

                <div class="absolute right-3 top-1/2 -translate-y-1/2">
                    <PhCaretDown
                        :class="[
                            { '[transform:rotateX(180deg)]': profileMenuOpen },
                            'w-6 flex-shrink-0 transition-transform translate-x-',
                        ]"
                    />
                </div>
            </div>
            <VerticalSlideTransition :show="profileMenuOpen" :keepAlive="true">
                <div class="flex flex-col">
                    <template v-for="(item, i) in profileItems">
                        <DynamicLink
                            v-if="item.route"
                            :href="item.route"
                            @click="() => $emit('linkClicked', item)"
                        >
                            <div
                                :class="[
                                    { 'border-t': i == 0 },
                                    {
                                        'bg-sidebar-active text-sidebar-active-text':
                                            item.active,
                                    },
                                    linkClasses,
                                ]"
                            >
                                <p v-text="item.text"></p>
                                <PhArrowRight class="w-6" />
                            </div>
                        </DynamicLink>
                    </template>
                    <button @click="logout" :class="linkClasses">
                        <p v-text="$lang.get('Log out')"></p>
                        <PhArrowRight class="w-6" />
                    </button>
                </div>
            </VerticalSlideTransition>
        </div>
    </div>
</template>
<script>
import DynamicLink from '@/Components/Utilities/DynamicLink.vue'
import { Link, router } from '@inertiajs/vue3'
import { PhCaretDown, PhArrowRight, PhUser } from '@phosphor-icons/vue'
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'

export default {
    components: {
        VerticalSlideTransition,
        PhCaretDown,
        PhArrowRight,
        PhUser,
        Link,
        DynamicLink,
    },

    props: {
        profileMenuOpen: {
            type: Boolean,
            required: true,
        },
        profileItems: {
            type: Array,
            required: true,
        },
    },

    emits: ['linkClicked', 'toggleProfileMenu'],

    data: () => ({
        hadImageError: false,
    }),

    beforeCreate() {
        this.padding = 'pl-11 pr-6'
        this.linkClasses =
            'underline-hover transition-colors duration-button-hover w-full justify-between text-left pl-14 p-4 border-b border-sidebar-border text-md flex gap-x-2'
    },
    methods: {
        logout() {
            router.post(route('logout'))
        },
    },
}
</script>
